module.exports = __webpack_public_path__ + "static/media/image3.c65ee224.png";